import { takeLatest, put, call } from 'redux-saga/effects';

import { listProdutoAgricolaCadastro } from '../service';
import {
  TABLE_PRODUTO_AGRICOLA_CADASTRO,
  TABLE_PRODUTO_AGRICOLA_CADASTRO_PENDING,
  TABLE_PRODUTO_AGRICOLA_CADASTRO_SUCCESS,
  TABLE_PRODUTO_AGRICOLA_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListProdutoAgricolaCadastro(action) {
  yield put({ type: TABLE_PRODUTO_AGRICOLA_CADASTRO_PENDING })

  try {
    const table = yield call(listProdutoAgricolaCadastro, action.args)
    yield put({ type: TABLE_PRODUTO_AGRICOLA_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_PRODUTO_AGRICOLA_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListProdutoAgricolaCadastro() {
  yield takeLatest(TABLE_PRODUTO_AGRICOLA_CADASTRO, sagaListProdutoAgricolaCadastro)
}